import {TaskBoardCard, TaskBoardColumn} from "../../api/Tasks2";
import {css} from "@emotion/css";
import {green, grey, orange, red} from "@mui/material/colors";
import {useContext} from "react";
import {BoardContext} from "./BoardContextProvider";
import {CompleteIcon} from "./CompleteIcon";
import {DraggableProvided} from "react-beautiful-dnd";
import DragIndicatorIcon from "@mui/icons-material/DragIndicator";
import {TagItem} from "./viewTask/TagItem";
import moment from "moment";

export function Card(props: {
    value: TaskBoardCard;
    column: TaskBoardColumn;

    provided: DraggableProvided;
}) {
    const ctx = useContext(BoardContext);
    const tags = props.value.task2Obj.tags || [];

    return (
        <div
             {...props.provided.draggableProps}
             ref={props.provided.innerRef}
        >
            <div className={cardCss}
                 style={{
                     opacity: props.value.isComplete ? 0.6 : 1,
                 }}
            >
                <div {...props.provided.dragHandleProps}>
                    <DragIndicatorIcon fontSize="inherit" />
                </div>
                <div style={{flex: 1}}>
                    <button
                        style={{
                            border: "none",
                            backgroundColor: "transparent",
                            cursor: "pointer",
                            textAlign: "left",
                            display: "flex",
                            alignItems: "flex-start",
                            flexDirection: "column",
                            width: "100%",
                        }}
                            onClick={() => ctx.onShowCard({
                                value: props.value.task2Obj,
                                column: props.column,
                                card: props.value,
                            })}
                    >
                        <div style={{
                            display: "flex",
                            alignItems: "center",
                            gap: 4,
                        }}>
                            {props.value.isComplete && <CompleteIcon mode="card" />}
                            <div>
                                {props.value.task2Obj.title}
                            </div>
                        </div>

                        {props.value.task2Obj.dueDate && <div style={{
                            marginTop: 3,
                            borderRadius: 8,
                            paddingLeft: 8, paddingRight: 8,
                            paddingTop: 1,
                            paddingBottom: 1,
                            backgroundColor:
                                moment(props.value.task2Obj.dueDate).isBefore(moment()) ? red["100"]:
                                    moment(props.value.task2Obj.dueDate).isBefore(moment().add(1, "day")) ? orange["300"] :
                                        green["100"],
                        }}>
                            Due: {moment(props.value.task2Obj.dueDate).format("YYYY-MMM-DD")}
                        </div>}

                        {tags.length > 0 && <div style={{
                            display: "flex",
                            flexDirection: "row",
                            gap: 4,
                            marginTop: 3,
                            opacity: 0.7
                        }}>
                            {tags.map(t => <TagItem key={t.id} color={t.color}>
                                {t.name}
                            </TagItem>)}
                        </div>}
                    </button>
                </div>
            </div>
        </div>
    )
}

export const cardCss = css({
    padding: 6,
    paddingLeft: 8,
    paddingRight: 8,
    backgroundColor: "white",
    borderRadius: 8,
    fontSize: "0.9rem",
    border: "1px solid " + grey["300"],
    textAlign: "left",
    display: "flex",
    alignItems: "center",
    gap: 4,
    cursor: "pointer",

    "&:hover": {
        opacity: "0.8",
    }
})